<template>
  <div id="app">
    <main id="page-wrap" >

      <div id="page_content">
        <router-view :key="$route.path" ></router-view>
      </div>
    </main>
  </div>
</template>

<script>

window.api_url = 'https://api.tov.tv/api/'; 

export default {
  name: 'app',
  
  data(){
    return {
    }
    
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Assistant:200,300,400,600,700,800&display=swap&subset=hebrew');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

</style>
